/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import StretchEnum from './stretch-enum';

/**
 * Knihovna pro určování roztažení založená na nativním web zpracování.
 * Využívá CSS vlastnost `object-fit`.
 */
class StretchNative {
  /**
   * Určí CSS třídu s roztažením, která se má přiřadit elementu.
   * @param {StretchEnum} stretchEnum Roztažení média.
   * @returns {string} Název CSS třídy.
   */
  getClassName(stretchEnum) {
    switch (stretchEnum) {
      case StretchEnum.CONTAIN:
        return 'stretch-native--contain';
      case StretchEnum.COVER:
        return 'stretch-native--cover';
      case StretchEnum.FILL:
        return 'stretch-native--fill';
      default:
        throw new Error(`Invalid stretch "${stretchEnum}".`);
    }
  }
}

export default StretchNative;
